import { Button } from '@parcel/ui';
import { AppLogo } from '@parcel/ui/app-logo';
import { Check, Copy } from 'lucide-react';
import * as React from 'react';

export function McpManualConfig({ configJson }: { configJson: string }) {
  const [copied, setCopied] = React.useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(configJson);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section aria-labelledby="mcp-manual-heading">
      <article className="rounded-lg border p-4">
        <div className="flex items-center gap-3">
          <span className="flex size-9 shrink-0 items-center justify-center rounded-md border bg-muted/40">
            <AppLogo name="mcp" size={20} className="text-foreground" aria-hidden />
          </span>
          <h3 id="mcp-manual-heading" className="text-sm font-medium">
            Manual configuration
          </h3>
        </div>
        <p className="mt-3 text-sm text-muted-foreground">
          Access your workspace data from your favorite MCP client like Claude, Codex or Cursor.
        </p>
        <div className="relative mt-3">
          <pre className="overflow-x-auto rounded-md bg-muted p-3 pr-12 text-xs leading-5">
            <code data-testid="mcp-manual-config">{configJson}</code>
          </pre>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            aria-label="Copy MCP client configuration"
            onClick={copy}
            className="absolute right-1.5 top-1.5 size-8 text-muted-foreground"
          >
            {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
          </Button>
        </div>
      </article>
    </section>
  );
}
